import { store } from '../../../store';
import { getRegion } from '../../../utils/Region';

export const getNameConfig = () => {
  const metadataNameConfig = JSON.parse(
    store.getState()?.metadata?.profiles_nameLength || '{}',
  );
  const nameConfigByRegion =
    metadataNameConfig[getRegion] || metadataNameConfig?.default || {};

  return {
    minLength: nameConfigByRegion?.min_value || 1,
    maxLength: nameConfigByRegion?.max_value || 25,
  };
};
